module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixedSections"
  }, [_c('div', {
    staticClass: "fixedSections-fixed"
  }, _vm._l((_vm.sections), function(section, index) {
    return (_vm.currentSection == index && section.fixedSection && !section.fullSection) ? _c('div', {
      key: section,
      staticClass: "fixedSections-section"
    }, [_c(section.fixedSection.sectionType, {
      tag: "component",
      class: {
        'bm-current': _vm.currentSection == index
      },
      attrs: {
        "data": section.fixedSection.data,
        "sharedData": section.sharedData
      }
    })], 1) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f54d65a8","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/globalBlocks/FixedSections.vue
// module id = 523
// module chunks = 0